import React from 'react';

import classNames from 'classnames';
import MoveCost from './MoveCost/MoveCost';

import { ReactComponent as BannerSvg } from './images/banner.svg';
import { ReactComponent as CircleSvg } from './images/circle.svg';
import { ReactComponent as HeartSvg } from './images/heart.svg';
import { ReactComponent as LightningSvg } from './images/lightning.svg';
import { ReactComponent as RareSvg } from './images/rare.svg';
import { ReactComponent as UncommonSvg } from './images/uncommon.svg';
import { ReactComponent as CommonSvg } from './images/common.svg';

import { TYPE, RARITY, ENERGY } from '../../data/characters';

import * as styles from './Card.module.scss';

export interface CardProps {
  number: number,
  name: string,
  subname?: string,
  health?: number,
  rarity: number,
  move?: {
    title?: string,
    description: string,
    cost?: {
      type: string,
      amount: number
    }
  },
  image: any,
  flipped?: boolean,
  type: number,
  animate?: boolean
};

const TYPE_LABEL = ['Character', 'Item'];

const getRarity = (rarity:number) => {
  switch (rarity) {
    case RARITY.RARE:
      return <RareSvg/>
    case RARITY.UNCOMMON:
      return <UncommonSvg/>
    case RARITY.COMMON:
      return <CommonSvg/>
  }
};

const StandardCard: React.FC<CardProps> = ({ number, name, subname, image, type, health, move, rarity }) => {
  return (
    <>
      <div className={styles.number}>
        <span>{ number }.</span>
      </div>
      <div className={styles.content}>
        <div className={styles.image}>
          <img src={ image } alt={ name }/>

          <div className={styles.circleInfo}>
            { type === TYPE.CHARACTER && (
              <div className={styles.metaInfo}>
                <div className={styles.metaInfoIcon}>
                  <CircleSvg/>
                  <HeartSvg className={styles.metaInfoIconTop}/>
                </div>
                { health }
              </div>
            ) }
          </div>

          <div className={styles.banner}>
            <BannerSvg className={styles.bannerImg}/>
            <p className={`${styles.bannerName} ${name.length > 12 && styles.bannerNameSmall}`}>{ name }{ subname && <span>{subname}</span> }</p>
          </div>
        </div>
        <div className={styles.info}>
          { type === TYPE.CHARACTER && <LightningSvg className={styles.moveIcon}/> }
          { move && (
            <div className={styles.move}>
              <p className={styles.moveTitle}>
                { move.title }
              </p>
              <p className={styles.moveDescription}>
                { move.description }
              </p>
              <div className={styles.moveCost}>{ typeof move.cost !== 'undefined' ? <MoveCost {...move.cost}/> : null }</div>
            </div>
          ) }
        </div>
      </div>
      <div className={styles.rarity}>{ getRarity(rarity) }</div>
      <div className={styles.type}>{ TYPE_LABEL[type] }</div>
    </>
  )
}

interface EnergyCardProps {
  type: string;
  image: string
};
const EnergyCard: React.FC<EnergyCardProps> = ({ type, image }) => {
  const cls = classNames(
    styles.content,
    {
      [styles.lantern]: type === ENERGY.LANTERN
    },
    {
      [styles.candy]: type === ENERGY.CANDY
    }
  );
  return (
    <div className={cls}>
      <div className={styles.center}>
        <img src={image} alt=""/>
      </div>
    </div>
  );
};

const Card : React.FC<CardProps> = ({ type, flipped = false, animate = false, ...cardData }) => {
  const cls = classNames(
    styles.wrap,
    {
      [styles.flipped]: flipped
    },
    {
      [styles.character]: type === TYPE.CHARACTER
    },
    {
      [styles.item]: type === TYPE.ITEM
    },
    {
      [styles.animate]: animate
    },
  );

  return (
    <div className={cls}>
      <div className={styles.card}>
        { type === TYPE.ENERGY ? (
          <EnergyCard type={cardData.name} image={cardData.image}/>
        ) : (
          <StandardCard type={type} {...cardData}/>
         )
        }
      </div>

      <div className={styles.back}/>
    </div>
  );
};

Card.defaultProps = {
  number: 1,
  name: 'Wirt',
  health: 40,
  move: {
    title: 'Pessimism',
    description: 'Take 10 damage to yourself, to deal 20',
    cost: {
      type: 'candy',
      amount: 2
    }
  },
};

export default Card;
